/* Event string shortcuts */
export const TRANSITION_END = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
export const ANIMATION_END = 'webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd animationend'

export function getTransform(el) {
  var values = el.style.transform.split(/\w+\(|\);?/);
  if (!values[1] || !values[1].length) {
    return [];
  }
  return values[1].split(/,\s?/g);
}
